import { AnneeScolaireDocument } from "./AnneeScolaireDocument";
import { ClasseScolaireDocument } from "./ClasseScolaireDocument";
import { ClasseScolaireEnseignantDocument } from "./ClasseScolaireEnseignantDocument";
import { ClasseScolaireNiveauDocument } from "./ClasseScolaireNiveauDocument";
import { EnseignantScolaireDocument } from "./EnseignantScolaireDocument";
import { EtablissementScolaireDocument } from "./EtablissementScolaireDocument";
import { EtablissementScolaireNiveauDocument } from "./EtablissementScolaireNiveauDocument";
import { NiveauScolaireDocument } from "./NiveauScolaireDocument";

export class FiltreScolarite {
    private listClasses: Array<ClasseScolaireDocument>;
    private listEcoles: Array<EtablissementScolaireDocument>;
    private listInstits: Array<EnseignantScolaireDocument>;
    private listNiveau: Array<NiveauScolaireDocument>;
    private currentAnneeScolaire: AnneeScolaireDocument;
    private listEtablissementScolaireNiveau: Array<EtablissementScolaireNiveauDocument>
    private listClasseScolaireNiveau: Array<ClasseScolaireNiveauDocument>;
    private listClasseScolaireEnseignant: Array<ClasseScolaireEnseignantDocument>;

    public constructor() {
        this.listClasses = new Array();
        this.listEcoles = new Array();
        this.listInstits = new Array();
        this.listNiveau = new Array();
        this.currentAnneeScolaire = new AnneeScolaireDocument({});
        this.listEtablissementScolaireNiveau = new Array();
        this.listClasseScolaireNiveau = new Array();
        this.listClasseScolaireEnseignant = new Array();
    }

    public getListClasses(): Array<ClasseScolaireDocument> {
        return this.listClasses;
    }

    public setListClasses(listClasses: Array<ClasseScolaireDocument>): void {
        this.listClasses = listClasses;
    }

    public getListEcoles(): Array<EtablissementScolaireDocument> {
        return this.listEcoles;
    }

    public setListEcoles(listEcoles: Array<EtablissementScolaireDocument>): void {
        this.listEcoles = listEcoles;
    }

    public getListInstits(): Array<EnseignantScolaireDocument> {
        return this.listInstits;
    }

    public setListInstits(listInstits: Array<EnseignantScolaireDocument>): void {
        this.listInstits = listInstits;
    }

    public getListNiveau(): Array<NiveauScolaireDocument> {
        return this.listNiveau;
    }

    public setListNiveau(listNiveau: Array<NiveauScolaireDocument>): void {
        this.listNiveau = listNiveau;
    }

    public getCurrentAnneeScolaire(): AnneeScolaireDocument {
        return this.currentAnneeScolaire;
    }

    public setCurrentAnneeScolaire(currentAnneeScolaire: AnneeScolaireDocument): void {
        this.currentAnneeScolaire = currentAnneeScolaire;
    }

    public getListEtablissementScolaireNiveau(): Array<EtablissementScolaireNiveauDocument> {
        return this.listEtablissementScolaireNiveau;
    }

    public setListEtablissementScolaireNiveau(listEtablissementScolaireNiveau: Array<EtablissementScolaireNiveauDocument>): void {
        this.listEtablissementScolaireNiveau = listEtablissementScolaireNiveau;
    }

    public getListClasseScolaireNiveau(): Array<ClasseScolaireNiveauDocument> {
        return this.listClasseScolaireNiveau;
    }

    public setListClasseScolaireNiveau(listClasseScolaireNiveau: Array<ClasseScolaireNiveauDocument>): void {
        this.listClasseScolaireNiveau = listClasseScolaireNiveau;
    }

    public getListClasseScolaireEnseignant(): Array<ClasseScolaireEnseignantDocument> {
        return this.listClasseScolaireEnseignant;
    }

    public setListClasseScolaireEnseignant(listClasseScolaireEnseignant: Array<ClasseScolaireEnseignantDocument>): void {
        this.listClasseScolaireEnseignant = listClasseScolaireEnseignant;
    }

}